import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-app-add-ticket-category',
  templateUrl: './app-add-ticket-category.component.html',
  styleUrls: ['./app-add-ticket-category.component.scss'],
  standalone: false
})
export class AppAddTicketCategoryComponent {


  category_id: any;
  event_id: any;
  user_id: any;
  event_name: any;
  subscription: any;
  category: any;
  color: any;
  total_category_tickets: any;
  max_allowed: any;
  auto_assign: any;

  ticket_amount: number = 0;

  convenience_type: 'flat' | 'percentage' | null = null;
  convenience_fee: number = 0;

  total_convenience_fee: number = 0;
  total_amount: number = 0;

  cgst_per: any = 0;
  sgst_per: any = 0;
  igst_per: any = 0;

  cgst_amt: any = 0;
  sgst_amt: any = 0;
  igst_amt: any = 0;

  other_charges: any = 0;
  total_charges: any = 0;


  ticketSetupList: Array<{ start_from: any; row: any; no_of_tickets: any }> = [
    { start_from: null, row: null, no_of_tickets: null }
  ];

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event_id = params['event_id'];
      this.user_id = params['user_id'];
    })
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  clearZero(field: string) {
    if ((this as any)[field] === 0) {
      (this as any)[field] = null;
    }
  }

  restoreZero(field: string) {
    if ((this as any)[field] === null || (this as any)[field] === '') {
      (this as any)[field] = 0;
    }
  }

  addTicketSetup() {
    this.ticketSetupList.push({ start_from: null, row: null, no_of_tickets: null });
  }

  // Remove a ticket setup field by index
  removeTicketSetup(index: number) {
    if (this.ticketSetupList.length > 1) {
      this.ticketSetupList.splice(index, 1);
    }
  }

  calculateTotals() {
    const ticketAmount = Number(this.ticket_amount || 0);
    const feeInput = Number(this.convenience_fee || 0);
    const other = Number(this.other_charges || 0);

    /* --------------------
       CONVENIENCE CALC
       (OUTPUT)
    -------------------- */
    this.total_convenience_fee = 0;

    if (this.convenience_type === 'flat') {
      this.total_convenience_fee = feeInput;
    }

    if (this.convenience_type === 'percentage') {
      this.total_convenience_fee = (ticketAmount * feeInput) / 100;
    }

    this.total_convenience_fee = +this.total_convenience_fee.toFixed(2);

    /* --------------------
       GST CALC
       (ONLY on convenience)
    -------------------- */
    const gstBase = this.total_convenience_fee;

    this.cgst_amt = +(gstBase * (this.cgst_per || 0) / 100).toFixed(2);
    this.sgst_amt = +(gstBase * (this.sgst_per || 0) / 100).toFixed(2);
    this.igst_amt = +(gstBase * (this.igst_per || 0) / 100).toFixed(2);

    /* --------------------
       TOTAL CHARGES
    -------------------- */
    this.total_charges =
      this.total_convenience_fee +
      this.cgst_amt +
      this.sgst_amt +
      this.igst_amt +
      Number(this.other_charges || 0);

    this.total_charges = +this.total_charges.toFixed(2);

    /* --------------------
       FINAL PAYABLE
    -------------------- */
    this.total_amount = +(ticketAmount + this.total_charges).toFixed(2);
  }


  Update_Setting() {

    // ---------- GST VALIDATION ----------
    const hasCGST = this.cgst_per > 0 || this.sgst_per > 0;
    const hasIGST = this.igst_per > 0;

    if (hasCGST && hasIGST) {
      this.toast.error('Use either CGST + SGST OR IGST, not both');
      return;
    }

    if (hasCGST && (!this.cgst_per || !this.sgst_per)) {
      this.toast.error('Both CGST and SGST are required');
      return;
    }

    if (hasIGST && this.igst_per <= 0) {
      this.toast.error('IGST must be greater than 0');
      return;
    }


    var filteredTickets = this.ticketSetupList.filter(ticket =>
      ticket.start_from !== null && ticket.row !== null && ticket.no_of_tickets !== null
    );

    if (!this.category || this.ticket_amount === null || this.ticket_amount === undefined || !this.total_category_tickets || !this.auto_assign || !this.color) {
      this.toast.warning('All fields are required');
      return;
    }

    // Sum up all no_of_tickets from ticketSetupList
    const totalEnteredTickets = this.ticketSetupList.reduce((sum, ticket) => sum + (Number(ticket.no_of_tickets) || 0), 0);

    // Now compare
    if (this.total_category_tickets < totalEnteredTickets) {
      alert('"Total Tickets" and sum of "No of Tickets" should be the same');
      return;
    }

    if (this.ticketSetupList.length == 1) {
      filteredTickets = [{ start_from: 1, row: '', no_of_tickets: this.total_category_tickets }];
    } else {
      for (let ticket of this.ticketSetupList) {
        if (!ticket.start_from || !ticket.row || !ticket.no_of_tickets) {
          this.toast.warning('All Ticket Setup fields must be filled');
          return;
        }
      }
    }

    const ticket_data: any = {
      event_id: this.event_id,
      user_id: this.user_id,
      category: this.category,
      color: this.color,

      ticket_amount: this.ticket_amount,
      convenience_type: this.convenience_type,
      convenience_fee: this.convenience_fee,
      total_convenience_fee: this.total_convenience_fee,

      cgst_per: this.cgst_per,
      sgst_per: this.sgst_per,
      igst_per: this.igst_per,

      cgst_amt: this.cgst_amt,
      sgst_amt: this.sgst_amt,
      igst_amt: this.igst_amt,

      other_charges: this.other_charges,
      total_charges: this.total_charges,
      total_amount: this.total_amount,

      total_category_tickets: this.total_category_tickets,
      max_allowed: this.max_allowed,
      auto_assign: this.auto_assign,
    };


    if (filteredTickets.length > 0) {
      ticket_data.ticket_array = filteredTickets;
    }

    this.service.app_add_ticket_category(ticket_data).subscribe({
      next: (data: any) => {
        if (data.flag === true) {
          this.toast.success(data.msg);

          // ✅ reset form after success
          this.resetForm();
        } else {
          this.toast.error(data.msg);
        }
      },
      error: (err) => {
        console.error(err);
        this.toast.error('Something went wrong');
      }
    });

  }

  resetForm() {
    this.category = null;
    this.color = null;
    this.total_category_tickets = null;
    this.max_allowed = null;
    this.auto_assign = null;

    this.ticket_amount = 0;

    this.convenience_type = null;
    this.convenience_fee = 0;
    this.total_convenience_fee = 0;

    this.cgst_per = 0;
    this.sgst_per = 0;
    this.igst_per = 0;

    this.cgst_amt = 0;
    this.sgst_amt = 0;
    this.igst_amt = 0;

    this.other_charges = 0;
    this.total_charges = 0;
    this.total_amount = 0;

    // Reset ticket setup list
    this.ticketSetupList = [
      { start_from: null, row: null, no_of_tickets: null }
    ];
  }

}
